// extracted by mini-css-extract-plugin
export default {"main":"cards_main__FXjzV","imgblock":"cards_imgblock__W1Qi1","image":"cards_image__2O-sQ"};